import DemoOutputWrapper, {
  Props,
} from '@/components/Demo/OutputWrapper';

function OutputWrapper(props: Props) {
  return (
    <DemoOutputWrapper
      {...props}
      layout={false}
      padding={0}
      // Don't use the '--adaptive-white' color here because it causes color contrast failures with the code snippet (that darkens an  already-darker-than-white background).
      style={{ backgroundColor: 'white' }}
    />
  );
}

export default OutputWrapper;
